import styled, { css } from 'styled-components'

import type { ConcealedTextProps } from './types'

export const Wrapper = styled.span``

export const Content = styled.div<{
  $isHidden: boolean
  $hiddenColor: ConcealedTextProps['hiddenColor']
}>`
  ${({ $isHidden, $hiddenColor }) =>
    $isHidden &&
    css`
      user-select: none;

      ${Wrapper} {
        color: ${$hiddenColor};
        background: ${$hiddenColor};
      }
    `};
`
